import{jsx as o,jsxs as a}from"react/jsx-runtime";import{useRef as h,useState as x}from"react";import s from"styled-components";import{TinyTitleRegular as v}from"../../typography/Heading/index.js";import b from"../../icons/components/AlertIcon.js";import k from"../../icons/components/CheckCircleIcon.js";import y from"../../icons/components/CloseIcon.js";import $ from"../../icons/components/InfoIcon.js";import w from"../../icons/components/WarningIcon.js";import{resetButtonStyle as C}from"../../utils/utils.js";import"../../shared/media-queries.js";const T=(e,r,t)=>{const n=t.colors.text.dark,i=t.colors.background.light;switch(e){case"info":return{text:r?t.colors.info.dark:n,background:r?i:t.colors.info.lighter};case"success":return{text:r?t.colors.success.dark:n,background:r?i:t.colors.success.lighter};case"warning":return{text:r?t.colors.warning.dark:n,background:r?i:t.colors.warning.lighter};case"error":return{text:r?t.colors.error.dark:n,background:r?i:t.colors.error.lighter};case"text":default:return{text:r?t.colors.text.light:n,background:r?t.colors.background.dark:i}}},j=e=>{switch(e){case"success":return o(k,{});case"warning":return o(w,{});case"error":return o(b,{});case"info":case"text":default:return o($,{})}},D=s.div`
  ${({isDeleted:e})=>e&&`
      opacity: 0;
      transition: opacity 0.3s;
    `}
`,W=s.div`
  display: ${({fullWidth:e})=>e?"flex":"inline-flex"};
  ${({fullWidth:e})=>e&&"justify-content: space-between;"}
  align-items: center;
  padding: 0 1.5rem;
  box-shadow: ${({theme:e})=>e.elevations.elevation2};

  ${({textCenter:e})=>e&&`
      justify-content: center;
    `}

  ${({theme:e,messageType:r,inverted:t})=>{const{text:n,background:i}=T(r,t,e);return`
      color: ${n};
      background-color: ${i};
    `}}
`,R=s.div`
  display: flex;
`,S=s.div`
  padding: 0.75rem 0;
`,z=s(v)`
  margin: 0;
`,P=s.span`
  display: flex;
  align-items: center;
  margin-right: 1rem;
  font-size: 1.5rem;
`,A=s.button`
  ${C}
  display: flex;
  align-items: center;
  margin-left: 1rem;

  &:focus-visible {
    outline: revert;
  }

  &:hover {
    cursor: pointer;
  }

  svg {
    font-size: 2.5rem;
  }
`,B=({children:e,type:r,withIcon:t=!1,isDeletable:n=!1,fullWidth:i=!1,inverted:c=!1,textCenter:d=!1,...u})=>{const l=h(null),[f,m]=x(!1),g=p=>{p.stopPropagation(),m(!0),setTimeout(()=>{l.current&&l.current.remove()},300)};return o(D,{isDeleted:f,children:a(W,{messageType:r,fullWidth:i,inverted:c,textCenter:d,role:r==="error"||r==="warning"?"alert":void 0,"aria-live":r==="error"||r==="warning"?"assertive":"polite",ref:l,...u,children:[a(R,{children:[t&&o(P,{children:j(r)}),a(S,{children:[typeof e=="string"&&o(z,{children:e}),typeof e!="string"&&e]})]}),n&&o(A,{onClick:g,"aria-label":"Close",type:"button",children:o(y,{})})]})})};export{B as default};
